var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[_c('vue-progress-bar'),_c('Sidebar',{staticClass:"app__sidebar"}),_c('div',{staticClass:"app__main"},[_c('router-view')],1),_c('Ticker',{staticClass:"app__ticker"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }